// extracted by mini-css-extract-plugin
export default {"input":"SearchInput_input__KhHTv","searchIcon":"SearchInput_searchIcon__8G60c"};